import React from "react";
import styled from "styled-components";
import Section from "../../components/Section";

const Heading = styled(Section)`
  margin-top: 70px;
  ${({ isNotHome }) => isNotHome && "cursor: pointer;"};

  p {
    font-weight: normal;
    font-size: 54px;
    line-height: 63px;
    margin: 0;

    span {
      color: #2075bc;
    }
  }
`;

export default ({ backHome, isNotHome }) => {
  return (
    <Heading isNotHome={isNotHome} onClick={isNotHome ? backHome : null}>
      <p>
        Оценка финалистов городского конкурса профессионального мастерства
        <br />
        <span>«Московские мастера»</span> в 2026 году
        <br />
        по профессии <span>«Библиотекарь»</span>
      </p>
    </Heading>
  );
};
